import ExtraFieldsComponent from './ExtraFieldsComponentContainer';

export default ExtraFieldsComponent;
